import { mergeProps } from '@base-ui/react';
import { Timeline, type TimelineProps } from 'primereact/timeline';
import styles from './fuuze-timeline.module.css';

export function FuuzeTimeline(props: TimelineProps) {
  return (
    <Timeline
      {...props}
      pt={{
        root: mergeProps({ className: styles.root }, props.pt?.root || {}),
        connector: mergeProps({ className: styles.connector }, props.pt?.connector || {}),
        content: mergeProps({ className: styles.content }, props.pt?.content || {}),
        marker: mergeProps({ className: styles.marker }, props.pt?.marker || {}),
        opposite: mergeProps({ className: styles.opposite }, props.pt?.opposite || {}),
        separator: mergeProps({ className: styles.separator }, props.pt?.separator || {}),
        event: mergeProps({ className: styles.event }, props.pt?.event || {}),
      }}
    />
  );
}
